import axios from "axios";

export default {
  namespaced: true,

  state: {
    incomingExchanges: [],
    outgoingExchanges: [],
    exchangeId: null,
    choosenFiles: [],
    exchangeCopyChoosenFiles: [],
    exchange: {
      code: "",
      encrypted: false,
      expired: false,
      files: [],
      id: null,
      message: null,
      receivers: [],
      sender: null,
      sharedAt: null,
      status: null,
      validUntil: null
    },
    incompleteExchanges: [],
    participants: [],
    rawFileCode: null,
    dateTimes: [
      {
        label: "06:00",
        timeInMinutes: 360
      },
      {
        label: "06:30",
        timeInMinutes: 390
      },
      {
        label: "07:00",
        timeInMinutes: 420
      },
      {
        label: "07:30",
        timeInMinutes: 450
      },
      {
        label: "08:00",
        timeInMinutes: 480
      },
      {
        label: "08:30",
        timeInMinutes: 510
      },
      {
        label: "09:00",
        timeInMinutes: 540
      },
      {
        label: "09:30",
        timeInMinutes: 570
      },
      {
        label: "10:00",
        timeInMinutes: 600
      },
      {
        label: "10:30",
        timeInMinutes: 630
      },
      {
        label: "11:00",
        timeInMinutes: 660
      },
      {
        label: "11:30",
        timeInMinutes: 690
      },
      {
        label: "12:00",
        timeInMinutes: 720
      },
      {
        label: "12:30",
        timeInMinutes: 750
      },
      {
        label: "13:00",
        timeInMinutes: 780
      },
      {
        label: "13:30",
        timeInMinutes: 810
      },
      {
        label: "14:00",
        timeInMinutes: 840
      },
      {
        label: "14:30",
        timeInMinutes: 870
      },
      {
        label: "15:00",
        timeInMinutes: 900
      },
      {
        label: "15:30",
        timeInMinutes: 930
      },
      {
        label: "16:00",
        timeInMinutes: 960
      },
      {
        label: "16:30",
        timeInMinutes: 990
      },
      {
        label: "17:00",
        timeInMinutes: 1020
      },
      {
        label: "17:30",
        timeInMinutes: 1050
      },
      {
        label: "18:00",
        timeInMinutes: 1080
      },
      {
        label: "18:30",
        timeInMinutes: 1110
      },
      {
        label: "19:00",
        timeInMinutes: 1140
      },
      {
        label: "19:30",
        timeInMinutes: 1170
      },
      {
        label: "20:00",
        timeInMinutes: 1200
      },
      {
        label: "20:30",
        timeInMinutes: 1230
      },
      {
        label: "21:00",
        timeInMinutes: 1260
      },
      {
        label: "21:30",
        timeInMinutes: 1290
      },
      {
        label: "22:00",
        timeInMinutes: 1320
      },
      {
        label: "22:30",
        timeInMinutes: 1350
      },
      {
        label: "23:00",
        timeInMinutes: 1380
      },
      {
        label: "23:30",
        timeInMinutes: 1410
      },
      {
        label: "00:00",
        timeInMinutes: 0
      },
      {
        label: "00:30",
        timeInMinutes: 30
      },
      {
        label: "01:00",
        timeInMinutes: 60
      },
      {
        label: "01:30",
        timeInMinutes: 90
      },
      {
        label: "02:00",
        timeInMinutes: 120
      },
      {
        label: "02:30",
        timeInMinutes: 150
      },
      {
        label: "03:00",
        timeInMinutes: 180
      },
      {
        label: "03:30",
        timeInMinutes: 210
      },
      {
        label: "04:00",
        timeInMinutes: 240
      },
      {
        label: "04:30",
        timeInMinutes: 270
      },
      {
        label: "05:00",
        timeInMinutes: 300
      },
      {
        label: "05:30",
        timeInMinutes: 330
      }
    ]
  },

  actions: {
    getOutgoingExchanges: async ({ commit, dispatch }) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `/outgoing/exchange?status=COMMITTED&size=500`,
          data: {},
          method: "GET"
        })
          .then(res => {
            if (res.data && res.data.content) {
              commit("updateOutgoingExchanges", res.data.content);
            }
            resolve(res);
          })
          .catch(err => {
            const title = err.response.data
              ? err.response.data.errorCode
              : err.errorCode;
            dispatch(
              "common/showModal",
              {
                title
              },
              { root: true }
            );
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    },

    getIncomingExchanges: async ({ commit, dispatch }) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `/incoming/exchange?size=500`,
          data: {},
          method: "GET"
        })
          .then(res => {
            if (res.data && res.data.content) {
              commit("updateIncomingExchanges", res.data.content);
            }
            resolve(res);
          })
          .catch(err => {
            const title = err.response.data
              ? err.response.data.errorCode
              : err.errorCode;
            dispatch(
              "common/showModal",
              {
                title
              },
              { root: true }
            );
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    },

    getIncompleteExchanges: async ({ commit, dispatch }) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `/outgoing/exchange?status=DRAFT&size=500`,
          data: {},
          method: "GET"
        })
          .then(res => {
            if (res.data && res.data.content) {
              commit("updateIncompleteExchanges", res.data.content);
            }
            resolve(res);
          })
          .catch(err => {
            const title = err.response.data
              ? err.response.data.errorCode
              : err.errorCode;
            dispatch(
              "common/showModal",
              {
                title
              },
              { root: true }
            );
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    },

    createExchange: async ({ commit, dispatch }) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `/outgoing/exchange`,
          data: {},
          method: "POST"
        })
          .then(res => {
            if (res.data && res.data.id) {
              commit("updateExchangeId", res.data.id);
              commit("updateExchange", res.data);
              resolve(res);
            }
          })
          .catch(err => {
            const title = err.response.data
              ? err.response.data.errorCode
              : err.errorCode;
            dispatch(
              "common/showModal",
              {
                title
              },
              { root: true }
            );
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    },

    setChoosenFiles: async ({ commit }, payload) => {
      let choosenFiles = [];
      for (let i = 0; i < payload.length; i++) {
        let file = payload[i];
        choosenFiles.push(file);
      }
      commit("updateChoosenFiles", choosenFiles);
    },

    deleteChoosenFile: async ({ commit }, index) => {
      commit("deleteChoosenFile", index);
    },

    deleteExchangeCopyChoosenFile: async ({ commit }, index) => {
      commit("deleteExchangeCopyChoosenFile", index);
    },

    deleteFile: async ({ dispatch }, payload) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `/outgoing/exchange/${payload.exchangeId}/file/${
            payload.fileId
          }`,
          method: "DELETE"
        })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            const title = err.response.data
              ? err.response.data.errorCode
              : err.errorCode;
            dispatch(
              "common/showModal",
              {
                title
              },
              { root: true }
            );
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    },

    getExchange: async ({ commit, dispatch }, payload) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `/outgoing/exchange/${payload.id}`,
          method: "GET"
        })
          .then(res => {
            commit("updateExchange", res.data);
            resolve(res);
          })
          .catch(err => {
            const title = err.response.data
              ? err.response.data.errorCode
              : err.errorCode;
            dispatch(
              "common/showModal",
              {
                title
              },
              { root: true }
            );
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    },

    updateExchange: async ({ dispatch }, payload) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `/outgoing/exchange/${payload.id}`,
          method: "PUT",
          data: payload.formData
        })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            const title =
              err.response && err.response.data
                ? err.response.data.errorCode
                : err.errorCode;
            dispatch(
              "common/showModal",
              {
                title
              },
              { root: true }
            );
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    },

    sendExchange: async ({ dispatch }, id) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `/outgoing/exchange/${id}/send`,
          method: "POST"
        })
          .then(res => {
            dispatch("getOutgoingExchanges");
            dispatch("getIncomingExchanges");
            resolve(res);
          })
          .catch(err => {
            const title = err.response.data
              ? err.response.data.errorCode
              : err.errorCode;
            dispatch(
              "common/showModal",
              {
                title
              },
              { root: true }
            );
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    },

    getExchangeCopy: async ({ dispatch }, id) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `/outgoing/exchange/${id}/copy`,
          method: "POST"
        })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            const title = err.response.data
              ? err.response.data.errorCode
              : err.errorCode;
            dispatch(
              "common/showModal",
              {
                title
              },
              { root: true }
            );
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    },

    deleteIncomingExchange: async ({ dispatch }, code) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `/incoming/exchange/${code}`,
          method: "DELETE"
        })
          .then(res => {
            if (res && res.status === 200) {
              dispatch("getIncomingExchanges");
            }
            resolve(res);
          })
          .catch(err => {
            const title = err.response.data
              ? err.response.data.errorCode
              : err.errorCode;
            dispatch(
              "common/showModal",
              {
                title
              },
              { root: true }
            );
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    },

    deleteOutgoingExchange: async ({ dispatch }, id) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `/outgoing/exchange/${id}`,
          method: "DELETE"
        })
          .then(res => {
            if (res && res.status === 200) {
              dispatch("getOutgoingExchanges");
            }
            resolve(res);
          })
          .catch(err => {
            const title = err.response.data
              ? err.response.data.errorCode
              : err.errorCode;
            dispatch(
              "common/showModal",
              {
                title
              },
              { root: true }
            );
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    },

    clearExchangeDraftFromState: async ({ commit }, exchangeId) => {
      commit("clearExchange", exchangeId);
    },

    getParticipantList: async ({ commit, dispatch }) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `/exchange/participants`,
          method: "GET"
        })
          .then(res => {
            if (res.data && res.data.content.length) {
              commit("updateParticipants", res.data);
            }
            resolve(res);
          })
          .catch(err => {
            const title = err.response.data
              ? err.response.data.errorCode
              : err.errorCode;
            dispatch(
              "common/showModal",
              {
                title
              },
              { root: true }
            );
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    },
    saveRawFileCode: async ({ commit }, code) => {
      commit("updateRawFileCode", code);
    },
    updateExchangeFiles: async ({ commit }, fileList) => {
      commit("updateExchangeFiles", fileList);
    },
    updateExchangeCopyChoosenFiles: async ({ commit }, fileList) => {
      commit("updateExchangeCopyChoosenFiles", fileList);
    },
    deleteChoosenFiles: async ({ commit }) => {
      commit("deleteChoosenFiles");
    },
    updateExchangeId: async ({ commit }, id) => {
      commit("updateExchangeId", id);
    }
  },

  mutations: {
    updateExchangeId: (state, payload) => {
      state.exchangeId = payload;
    },
    updateChoosenFiles: (state, payload) => {
      state.choosenFiles = [...state.choosenFiles, ...payload];
    },
    updateExchangeCopyChoosenFiles: (state, payload) => {
      state.exchangeCopyChoosenFiles = [...payload];
    },
    deleteChoosenFiles: state => {
      state.choosenFiles = [];
    },
    deleteChoosenFile: (state, index) => {
      if (state.choosenFiles.length === 1) {
        state.choosenFiles.splice(index, 1);
      } else {
        state.choosenFiles.splice(index, 1, null);
      }
    },
    deleteExchangeCopyChoosenFile: (state, index) => {
      if (state.exchangeCopyChoosenFiles.length === 1) {
        state.exchangeCopyChoosenFiles.splice(index, 1);
      } else {
        state.exchangeCopyChoosenFiles.splice(index, 1, null);
      }
    },
    updateExchangeFiles: (state, payload) => {
      state.exchange.files = payload;
    },
    updateIncompleteExchanges: (state, payload) => {
      state.incompleteExchanges = payload;
    },
    updateIncomingExchanges: (state, payload) => {
      state.incomingExchanges = payload;
    },
    updateOutgoingExchanges: (state, payload) => {
      state.outgoingExchanges = payload;
    },
    updateExchange: (state, payload) => {
      state.exchange = { ...state.exchange, ...payload };
    },
    clearExchange: (state, payload) => {
      if (state.exchangeId === payload) {
        state.exchange = {
          code: "",
          encrypted: false,
          expired: false,
          files: [],
          id: null,
          message: null,
          receivers: [],
          sender: null,
          sharedAt: null,
          status: null,
          validUntil: null
        };
      }
    },
    updateParticipants: (state, payload) => {
      let emailList = [];
      payload.content.map(email => {
        emailList.push({
          text: email,
          classes: "tag"
        });
      });
      state.participants = emailList;
    },
    updateRawFileCode: (state, payload) => {
      state.rawFileCode = payload;
    }
  }
};
